import {CONFIG} from "../../config";
import axios from "axios";

async function GetNuke(id) {
    const location = CONFIG.API_URL + "device/nuke/" + id;
    const settings = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('bearer-token')}`,
        }
    };

    try {
        return await axios.get(location, settings);
    } catch (e) {
        return null;
    }
}

export default GetNuke;